import { Product } from '../types/Product';

export const buildPriceExportRows = (products: Product[]): (string | number)[][] => {
  // Keep existing columns in place for the price-entry workflow.
  const rows: (string | number)[][] = [[
    'Ürün Kodu (SKU)', 'Renk Kodu', 'Renk Adı', 'Maliyet', 'Satış Fiyatı',
    'İndirimli Fiyat', 'Ürün Adı', 'Üretici', 'Durum', 'RPT Ürün'
  ]];

  products.forEach(product => {
    const colors = product.productionInfo?.colors || [];
    const status = product.nebimPriceUpdated
      ? 'Tamamlandı'
      : product.priceEntered ? 'Fiyat Girildi' : 'Fiyat Eksik';
    const baseRow = [
      product.nebimInfo?.sku || '',
      '',
      '',
      product.productionInfo?.costPrice || '',
      product.productionInfo?.salePrice || '',
      product.productionInfo?.discountPrice || '',
      product.productionInfo?.productName || '',
      product.productionInfo?.manufacturer || '',
      status,
      product.isRPT === true ? 'Evet' : 'Hayır'
    ];

    if (colors.length > 0) {
      colors.forEach(color => {
        rows.push([baseRow[0], color.code, color.name, ...baseRow.slice(3)]);
      });
    } else {
      rows.push(baseRow);
    }
  });

  return rows;
};
